import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';

import { AuthContext } from '../../../context';

import mutations from '../../../graphql/mutations';

import { formatTotals } from '../../../helpers';

import style from './follower-detail.module.scss';

const {
  userMutations: { FOLLOW_OR_UNFOLLOW_USER },
} = mutations;

function Follower({ follower }) {
  const { currentUser } = useContext(AuthContext);

  const isFollowing = follower.followers
    .map(follower => follower.id)
    .includes(currentUser.id);

  const handleFollow = async followOrUnfollowUser => {
    const res = await followOrUnfollowUser({
      variables: {
        input: {
          followerId: 'currentUser.id',
          userToFollowId: 'user.id',
          actionType: isFollowing ? 'unfollow' : 'follow',
        },
      },
    });

    console.log(res);
  };

  return (
    <div className={`row ${style.follower}`}>
      <div className={`col-12 ${style['col--info']}`}>
        <Link
          to={{
            pathname: `/account/${follower.fullname}`,
            state: {
              userId: follower.id,
            },
          }}
        >
          <img
            src={follower.imgUrl || 'https://imgur.com/qHpJwKV.png'}
            alt={follower.fullname}
            className={style.image}
          />
        </Link>
        <div>
          <Link
            to={{
              pathname: `/account/${follower.fullname}`,
              state: {
                userId: follower.id,
              },
            }}
          >
            <p className={style.fullname}>{follower.fullname}</p>
            {follower.bio && (
              <p className={`text-muted ${style.bio}`}>{follower.bio}</p>
            )}
          </Link>
        </div>
      </div>
      <div className={`col-12 ${style['col--action']}`}>
        <Mutation mutation={FOLLOW_OR_UNFOLLOW_USER}>
          {followOrUnfollowUser => (
            <span
              className={style.action}
              onClick={() => handleFollow(followOrUnfollowUser)}
            >
              <i
                style={{ marginRight: '0.25rem' }}
                className={`fas fa-user${isFollowing ? '' : '-plus'}`}
              />
              Follow{isFollowing ? 'ing' : ''}{' '}
              <span>{formatTotals(follower.followers.length)}</span>
            </span>
          )}
        </Mutation>
      </div>
    </div>
  );
}

Follower.propTypes = {
  follower: PropTypes.shape({
    fullname: PropTypes.string.isRequired,
    bio: PropTypes.string,
    imgUrl: PropTypes.string,
    followers: PropTypes.array.isRequired,
  }).isRequired,
};

export default Follower;
